<template>
  <div>
    <b-container style="margin-top: 4rem">
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>四川绵阳商行</b></h6>
        <hr />
        <b-form-group id="input-group-1" label="流水号:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="bankSerialNumber"
            required
            placeholder="银行流水号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCode"
            required
            placeholder="银行编号"
            :disabled="true"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="卡类型:" label-for="input-2">
          <!-- <b-form-input id="input-2" v-model="CardType" required placeholder="DIY卡类型: 000：默认001：萌宠"></b-form-input> -->
          <b-form-select
            v-model="CardType"
            :options="cardSubjects"
          ></b-form-select>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="testApplyCard()"
            >申请卡片</b-button
          >
          <b-button variant="outline-primary" @click="testQueryOrder()"
            >查询订单</b-button
          >
          <b-button variant="outline-primary" @click="getExpressageInfo()"
            >物流信息</b-button
          >
        </div>

        <div>
          <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
            <p>{{ errorMsg }}</p>
          </b-modal>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "Home_schmysh",
  data() {
    return {
      errorMsg: "",
      bankSerialNumber: "",
      bankCode: "0015",
      CardType: "000",
      cardSubjects: [
        {
          value: "000",
          text: "默认",
        },
        {
          value: "001",
          text: "萌宠",
        },
      ],
    };
  },
  mounted: function () {},
  methods: {
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    testApplyCard: function () {
      if (
        this.bankSerialNumber == null ||
        this.bankSerialNumber.trim().length == 0
      ) {
        this.errorMsg = "请输入流水号";
        this.showErrorMsg();
        return;
      }

      if (this.bankCode == null || this.bankCode.trim().length == 0) {
        this.errorMsg = "请输入银行编号";
        this.showErrorMsg();
        return;
      }

      if (this.CardType == null || this.CardType.trim().length == 0) {
        this.errorMsg = "请输入卡类型";
        this.showErrorMsg();
        return;
      }
      this.$router.push({
        name: "BaseApplyAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          CardType: this.CardType,
        },
      });
    },
    testQueryOrder: function () {
      if (
        this.bankSerialNumber == null ||
        this.bankSerialNumber.trim().length == 0
      ) {
        this.errorMsg = "请输入流水号";
        this.showErrorMsg();
        return;
      }

      if (this.bankCode == null || this.bankCode.trim().length == 0) {
        this.errorMsg = "请输入银行编号";
        this.showErrorMsg();
        return;
      }

      this.$router.push({
        name: "BaseQueryAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
        },
      });
    },
    getExpressageInfo: function () {
      if (
        this.bankSerialNumber == null ||
        this.bankSerialNumber.trim().length == 0
      ) {
        this.errorMsg = "请输入流水号";
        this.showErrorMsg();
        return;
      }
      axios
        .get(
          config.config_schmysh.getExpressageInfo + "/" + this.bankSerialNumber,
          {}
        )
        .then(function (response) {
          console.log(response);
          alert(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
          alert(error);
        });
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/sichuanmianyangbank/Home_schmysh.vue